import styled, { css } from 'styled-components';
import {
  GrowthLevelIndicator as _GrowthLevelIndicator,
  EllipsisPopout as _EllipsisPopout,
} from 'src/components';
import { hover } from 'src/components/utils';

export const RowWrapper = styled.div(
  ({ theme }) => css`
    position: relative;
    align-items: center;
    display: grid;
    grid-template-columns: auto 4fr 4fr 1fr;
    border-bottom: ${theme.bo.thinWidth} solid ${theme.co.secondary90};
    padding: ${theme.sz.s2} 0;
    min-width: inherit;
    gap: ${theme.sz.s2};

    @media (max-width: ${theme.sz.m}) {
      display: flex;
    }
  `,
);

export const Icon = styled.div(() => css``);

export const TextWrapper = styled.div(
  ({ theme }) => css`
    @media (max-width: ${theme.sz.m}) {
      flex-grow: 1;
      display: grid;
      padding: 0;
    }
  `,
);

export const TargetText = styled.span(
  ({ theme }) => css`
    text-align: start;
    font-weight: ${theme.DEPRECATED_ty.semiBold};
    font-size: ${theme.DEPRECATED_ty.smaller};
    padding: ${theme.sz.s2} ${theme.sz.s1};
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;

    @media (max-width: ${theme.sz.m}) {
      padding: 0 0 ${theme.sz.s1} 0;
    }
  `,
);

export const SourceText = styled.span(
  ({ theme }) => css`
    color: ${theme.co.secondary50};
    font-size: ${theme.DEPRECATED_ty.smaller};
    padding: ${theme.sz.s2} ${theme.sz.s1};
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;

    @media (max-width: ${theme.sz.m}) {
      padding: 0;
    }
  `,
);

export const GrowthLevelIndicator = styled(_GrowthLevelIndicator)(
  ({ theme }) => css`
    padding: ${theme.sz.s1};
  `,
);

export const EllipsisPopout = styled(_EllipsisPopout)(
  ({ theme }) => css`
    font-size: ${theme.sz.s6};
  `,
);

export const IconsWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: end;
    min-width: ${theme.sz.s20};

    @media (max-width: ${theme.sz.m}) {
      min-width: unset;
    }
  `,
);

export const TargetImage = styled.img(
  () => css`
    max-height: 3rem;
    max-width: 100%;
    object-fit: contain;
  `,
);

export const AudioButton = styled.button<{
  $isPlaying?: boolean;
}>(
  ({ theme, $isPlaying }) => css`
    padding: ${theme.sz.s1};
    background: none;
    border: none;
    border-radius: ${theme.bo.round};
    cursor: pointer;
    font-size: ${theme.sz.s6};

    display: flex;
    align-items: center;
    justify-content: center;

    ${
      $isPlaying &&
      css`
        background-color: ${theme.co.primary95};
      `
    }

    &:hover {
      background-color: ${hover(theme.co.neutral98)};
    }
  `,
);

export const ToastWrapper = styled.div(
  ({ theme }) => css`
    position: absolute;
    z-index: ${theme.zi.modal};
    top: ${theme.sz.s14};
    left: ${theme.sz.s8};
  `,
);
